import * as moment from "moment"
import * as lookup from "../../../../../static/lookup.json"
import * as dataLayerLookup from "../../../../../static/dataLayerEventTrigger.json"
import { getAge } from "../../helperFunctions"
import { MD5 } from "crypto-js"

export function invest4GDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)  {
    console.log(journeyState);
    let journeyId = journeyState?.journeyIdFromStrapi
    let allJourneyData = allJourneyDataResponse
    let lastDataLayerElement
    let dynamicEvent
    var clientId
    let FundSFINArray = []
    let FundSFIN
    let FundAllocationArray = []
    let FundAllocation
    let FundValue
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    window.dataLayer = window.dataLayer || [];
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }

    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.previousButtonEvent?.eventName 
    }else if(e === "proceed"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.proceedButtonEvent?.eventName
    }else if(e === "landing"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.landingPageEvent?.eventName
    }else {
        console.log(dataLayerLookup)
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
    }
    let pageNameHaveSource = window.location.href?.includes("source")
    if(dynamicEvent === "Inv4G_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
        return 
    }
    let spouseCover = allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "YES" : allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01" ? "NO" : ""

    let paymentOption 
    if(allJourneyData?.basicDetails?.paymentOption){
        if(allJourneyData?.basicDetails?.paymentOption === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else if(allJourneyData?.paymentStep){
        if(allJourneyData?.paymentStep === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else{
        paymentOption = ""
    }

    let funds = allJourneyData?.productDetails?.fundDetails?.funds
    if(funds && funds.length){
      funds.forEach(fund => {
        FundSFINArray.push(fund?.sfinNo)
        FundAllocationArray.push(fund?.allocationPercent)
      });
      FundSFIN = FundSFINArray.join('|')
      FundAllocation = FundAllocationArray.join('|')
    }
    let biJson = journeyState?.biJson ? journeyState?.biJson : null
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]);
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName);

    const urlParams = new URLSearchParams("?" + window?.location?.href?.split("?")?.[1])
    let sourceParameter
    if(urlParams){
         sourceParameter = urlParams.get("source")
    }

    if(dynamicEvent){
        window.dataLayer.push({
            "event" : dynamicEvent,
            "ProductName": "Invest 4G",
            "ProductCategory": "ULIP",
            "ProductSubCategory": "ULIP",
            "ProductCode": "90049",
            "PageType": "Buying Journey",
            "PageName": window.location.href,
            "PolicyType": "ULIP",
            "SectionName": dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName,
            "ClientID": clientId,
            "Source":  window?.location?.href ? lookup?.sourceChannelLookup?.[0][sourceParameter] : journeyState?.channel ? lookup?.sourcePartnerLookup?.[0][journeyState?.channel] : "",
            "Usertype": allJourneyData?.basicDetails?.existingCustomer ? allJourneyData?.basicDetails?.existingCustomer === "N" ? "New User" : "Returning User" : "n/a",
            "Name": allJourneyData?.lifeAssuredDetails?.fullName ? allJourneyData?.lifeAssuredDetails?.fullName : "n/a",
            "MobileNumber": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo)?.toString() : "n/a",
            "EmailID": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId)?.toString() : "n/a",
            "Gender": allJourneyData?.lifeAssuredDetails?.gender ? lookup?.["gender"]?.[0][allJourneyData?.lifeAssuredDetails?.gender] : "n/a",
            "DOB": allJourneyData?.lifeAssuredDetails?.dob ? moment.unix(allJourneyData?.lifeAssuredDetails?.dob).format('MM/YYYY') : "n/a",
            "Age": allJourneyData?.lifeAssuredDetails?.dob ? getAge(allJourneyData?.lifeAssuredDetails?.dob) : "n/a",
            "TobaccoConsumer": allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] : "n/a",
            "Education": allJourneyData?.lifeAssuredDetails?.employmentDetails?.education ? lookup?.["education"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] : "n/a",
            "AnnualIncome": allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) : "n/a",
            "ApplicationNumber": allJourneyData?.basicDetails?.applicationNumber ? allJourneyData?.basicDetails?.applicationNumber : "n/a",
            "Term": allJourneyData?.productDetails?.policyTerm ? Number(allJourneyData?.productDetails?.policyTerm) : "n/a",
            "PremiumPaymentTerm": allJourneyData?.productDetails?.premiumPaymentTerm ? allJourneyData?.productDetails?.premiumPaymentTerm : "n/a",
            "PaymentFrequency": allJourneyData?.productDetails?.premiumFrequency ? lookup?.["premiumFrequency"][0][allJourneyData?.productDetails?.premiumFrequency] : "n/a",
            "SumAssuredMultiplier": allJourneyData?.productDetails?.deathCover ? allJourneyData?.productDetails?.deathCover : 'n/a',
            "Country": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap ? lookup?.["countryCodeToCountry"]?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] : "n/a",
            "ResidentialStatus": allJourneyData?.lifeAssuredDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.lifeAssuredDetails?.residentStatus] : "n/a",
            "PinCode": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode : "n/a",
            "State": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state ? lookup?.["state"][0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] : "n/a",
            "Occupation": allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation ? lookup?.["occupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] : "n/a",
            "NatureOfDuties": allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation ? lookup?.["natureOfOccupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] : "n/a",
            "ExistingSumAssured": allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured ? allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured : "n/a",
            "PlanOption": allJourneyData?.productDetails?.planOption ? lookup?.["planOption"]?.[0][allJourneyData?.productDetails?.planOption] : "n/a",
            "PaymentOption": paymentOption,
            "PaymentMode": journeyState?.paymentDecryptData?.paymentMethod ? journeyState?.paymentDecryptData?.paymentMethod : "n/a",
            "NatureOfIndustry": allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry ? lookup?.["natureOfIndustry"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] : "n/a",
            "order_ID": journeyState?.paymentDecryptData?.paymentTxnId ? journeyState?.paymentDecryptData?.paymentTxnId : "n/a",
            "InsuranceRepository": allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository ? lookup?.["insuranceRepository"]?.[0][allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository] : "n/a",
            "NomineeDOB": allJourneyData?.nominees?.[0]?.dob ? moment.unix(allJourneyData?.nominees?.[0]?.dob).format('MM/YYYY') : "n/a",
            "NomineeEmail": allJourneyData?.nominees?.[0]?.emailId ? MD5(allJourneyData?.nominees?.[0]?.emailId)?.toString() : "n/a",
            "NomineeGender": allJourneyData?.nominees?.[0]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : "n/a",
            "NomineeRelationship": allJourneyData?.nominees?.[0]?.relationshipWithLa ? allJourneyData?.nominees?.[0]?.gender === "M" ? lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa] : lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa] : "n/a",
            'NachStatus': (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : (allJourneyData?.basicDetails?.enachSuccess === false ? "Fail" : "n/a"),
            'NachType': (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true) ? "Physical Mandate" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false ? "E-Mandate" : "n/a"),
            "SumAssured": allJourneyData?.productDetails?.sumAssured ? allJourneyData?.productDetails?.sumAssured : 'n/a',
            "City": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityMap ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityMap : "n/a",
            "Premium": journeyState?.premium ? journeyState?.premium : "n/a",
            "TotalPremium": journeyState?.premium ? journeyState?.premium : "n/a",
            "IsStaffMember": allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === 'Y' ? 'YES' : allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === 'N' ? 'NO' : 'n/a',
            "PlanBenefits" : journeyState?.planOption ? lookup?.invest4GPlanCode?.[0][journeyState?.planOption] : 'n/a',
            "safetySwitchOption" : allJourneyData?.productDetails?.safetySwitchOption === 'Y' ? 'YES' : allJourneyData?.productDetails?.safetySwitchOption === 'N' ? 'NO' : 'n/a',
            "withdrawlOptions" : allJourneyData?.productDetails?.withdrwalOption === 'SWO' ? 'systematic' : allJourneyData?.productDetails?.withdrwalOption === 'MWO' ? 'milestone' : 'n/a',
            "PortfolioMgmtOption" : allJourneyData?.productDetails?.sysTransferOption === 'STO' ? 'Systematic Transfer Option' : allJourneyData?.productDetails?.sysTransferOption === 'RPO' ? 'Return Protector Option' : allJourneyData?.productDetails?.sysTransferOption === 'AFR' ? 'Auto Funds Rebalancing' : 'n/a',
            "FundSFIN" : FundSFIN || 'n/a',
            "FundAllocation" : FundAllocation || 'n/a',
            "FundValue" : journeyState?.invest4GFundBiKeys ? `${journeyState?.invest4GFundBiKeys?.invest4GFundValue8Perc} | ${journeyState.invest4GFundBiKeys?.invest4GFundValue4Perc}` : 'n/a',
            // "SpouseCover" : spouseCover,
            // "SpouseOccupation" : spouseCover === "YES" ? lookup?.occupation?.[0][allJourneyData?.spouseDetails?.employmentDetails?.occupation] : "",
            // "SpouseGender" : spouseCover === 'YES' ? lookup?.gender?.[0][allJourneyData?.spouseDetails?.gender] : "",
            // "SpouseTobacco" : spouseCover === "YES" ? lookup['yesNo'][0][allJourneyData?.spouseDetails?.personalDetails?.smoking] : "",
            // "SpouseDOB" : spouseCover === "YES" ? moment.unix(allJourneyData?.spouseDetails?.dob).format('MM/YYYY') : "",
            // "SpouseCoverageOption" : spouseCover === "YES" ? lookup?.coverOption?.[0][allJourneyData?.productDetails?.spouseLaDetails?.spouseCoverOption] : "",
            // "SpouseSumAssured" : spouseCover === "YES" ? Number(allJourneyData?.productDetails?.spouseLaDetails?.spouseSa) : "",
            // "SpouseResidentialStatus" : spouseCover === "YES" ? lookup?.residentStatus?.[0][allJourneyData?.spouseDetails?.residentStatus] : "",
            // "SpouseAnnualIncome" : spouseCover === "YES" ? Number(allJourneyData?.spouseDetails?.employmentDetails?.annualIncome) : ""
        })
    }
}

export function invest4GTransactionDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState) {
    const emailID = allJourneyDataResponse?.journeyData?.basicDetails?.emailID;
    const mobileNo = allJourneyDataResponse?.journeyData?.basicDetails?.mobileNo;
    let encryptedEmail 
    let encryptedMobileNo
    try {
      encryptedEmail = MD5(emailID)?.toString();
      console.log(encryptedEmail, "encryptedEmail")
      encryptedMobileNo = MD5(mobileNo)?.toString();
      console.log(encryptedMobileNo, "encryptedMobileNo")
    }catch(err){
      console.log(err, "dsds")
    }
    
    const transactions = allJourneyDataResponse?.journeyData?.transactionDetails?.transactions
    
    var products = [];
    products.push({
      'name': 'Invest 4G',
      'id': '90049',                               //Product Code
      'category': 'ULIP',                     //Category of the Product
      'price': allJourneyDataResponse?.journeyData?.premium,                  //Product Price
      'quantity': '1'                         //Number of Products Purchased
    })

    var items = [];
    items.push({
        'item_id': "90049", //HSN Code/ITEM Code
        'item_name': "Invest 4G",
        'currency': "INR",
        'item_brand': "CanaraHSBC",
        'item_category': "ULIP", //Product Category
        'item_category2': "ULIP", //Product SubCategory
        'price': Number(allJourneyDataResponse?.journeyData?.premium), //individual product price
        'quantity': 1
    })

    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   'ecommerce': {
    //     'purchase': {
    //       'actionField': {
    //         'id': transactions?.[transactions.length -1]?.paymentTxnId,               //Transaction ID (String)
    //         'affiliation': 'Online Journey',      //Affiliation or Store Name
    //         'revenue': allJourneyDataResponse?.journeyData?.premium,                 //Total Revenue (inclusive of tax., shipping, etc.) (number) - Premium
    //         'tax': allJourneyDataResponse?.journeyData?.productDetails?.premServiceTax,
    //         'shipping': '',
    //         'coupon': ''
    //       },
    //       'products': products
    //     }
    //   }
    // });
    window.dataLayer.push({
        'event': "purchase",
        'ecommerce': {
            'transaction_id': transactions?.[transactions.length -1]?.paymentTxnId, // Unique transaction id of every purchase
            'affiliation': lookup?.sourcePartnerLookup?.[0][allJourneyDataResponse?.journeyData?.basicDetails?.channel],
            'value': Number(allJourneyDataResponse?.journeyData?.premium), // total booking amaount
            'tax': 'n/a', // tax on booking
            'currency': "INR",
            'coupon': "", //Coupon/Promo Code
            'discount': 0,
            'payment_type': transactions?.[transactions.length -1]?.paymentMethod,
            'items': items
        }
    })
}